import { useLanguage, t } from "../../../i18n";
import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/layout/Header/Header";
import MobileOffcanvasNav from "../../../components/layout/MobileOffcanvasNav/MobileOffcanvasNav";
import Footer from "../../../components/layout/Footer/Footer";
import ROUTES from "../../../config/routes";
import "./PrivacyPolicy.css";
export default function PrivacyPolicy() {
  useLanguage();
  const [showMobileNav, setShowMobileNav] = useState(false);
  const navigate = useNavigate();
  return <div className="bb-public-page bb-privacy-page">
      <Header onMenuClick={() => setShowMobileNav(true)} />

      <MobileOffcanvasNav show={showMobileNav} onHide={() => setShowMobileNav(false)} />


      <main className="bb-privacy-page__main">
        <Container>
          <section className="bb-privacy-page__hero">
            <div className="bb-privacy-page__hero-content">
              <span className="bb-privacy-page__eyebrow">{t("Legal")}</span>
              <h1 className="bb-privacy-page__title">{t("Privacy Policy")}</h1>
              <p className="bb-privacy-page__subtitle">{t("This Privacy Policy explains how BaytBuddy collects, uses, stores, processes, and protects personal data when users access the platform and its services.")}



              </p>

              <div className="bb-privacy-page__hero-actions">
                <Button variant="outline-primary" className="bb-brand-btn-outline" onClick={() => navigate(ROUTES.ROOT)}>{t("Back to Home")}


                </Button>
              </div>
            </div>
          </section>

          <section className="bb-privacy-page__meta-card">
            <p>
              <strong>{t("Last updated:")}</strong>{t(" 16 April 2026")}
            </p>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("1. Introduction")}</h2>
            <p>{t("BaytBuddy (\"BaytBuddy\", \"we\", \"our\", or \"us\") respects your privacy and is committed to protecting your personal data.")}


            </p>
            <p>{t("This Privacy Policy explains how we collect, use, store, process, and protect your information when you use the BaytBuddy website, mobile application, or services (collectively, the \"Platform\").")}



            </p>
            <p>{t("By using the Platform, you agree to the practices described in this Privacy Policy.")}


            </p>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("2. Scope of Policy")}</h2>
            <p>{t("This Privacy Policy applies to:")}</p>
            <ul>
              <li>{t("website visitors")}</li>
              <li>{t("registered users")}</li>
              <li>{t("property listers")}</li>
              <li>{t("roommate seekers")}</li>
              <li>{t("co-renting participants")}</li>
              <li>{t("individuals contacting BaytBuddy")}</li>
              <li>{t("users interacting with BaytBuddy services")}</li>
            </ul>
            <p>{t("This policy applies to personal data processed within the Kingdom of Saudi Arabia.")}


            </p>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("3. Information We Collect")}</h2>
            <p>{t("We collect only information necessary to operate the Platform safely and effectively.")}


            </p>

            <h3>{t("3.1 Information You Provide")}</h3>
            <p>{t("When creating an account or using the Platform, you may provide:")}

            </p>

            <div className="bb-privacy-page__subgroup">
              <h4>{t("Identity Information")}</h4>
              <ul>
                <li>{t("full name")}</li>
                <li>{t("nationality")}</li>
                <li>{t("gender, if provided")}</li>
                <li>{t("date of birth, if required")}</li>
                <li>{t("national ID or Iqama for verification purposes")}</li>
                <li>{t("profile photo, if optional upload is enabled")}</li>
              </ul>
            </div>

            <div className="bb-privacy-page__subgroup">
              <h4>{t("Contact Information")}</h4>
              <ul>
                <li>{t("email address")}</li>
                <li>{t("phone number")}</li>
                <li>{t("city of residence")}</li>
              </ul>
            </div>

            <div className="bb-privacy-page__subgroup">
              <h4>{t("Profile Information")}</h4>
              <ul>
                <li>{t("profession")}</li>
                <li>{t("lifestyle preferences")}</li>
                <li>{t("roommate preferences")}</li>
                <li>{t("budget preferences")}</li>
                <li>{t("preferred location")}</li>
                <li>{t("housing preferences")}</li>
              </ul>
            </div>

            <div className="bb-privacy-page__subgroup">
              <h4>{t("Listing Information")}</h4>
              <ul>
                <li>{t("property details")}</li>
                <li>{t("room details")}</li>
                <li>{t("pricing information")}</li>
                <li>{t("photos")}</li>
                <li>{t("descriptions")}</li>
              </ul>
            </div>

            <div className="bb-privacy-page__subgroup">
              <h4>{t("Communication Information")}</h4>
              <ul>
                <li>{t("messages exchanged through the Platform")}</li>
                <li>{t("inquiries submitted to support")}</li>
              </ul>
            </div>

            <h3>{t("3.2 Automatically Collected Information")}</h3>
            <p>{t("We may automatically collect technical information such as:")}

            </p>
            <ul>
              <li>{t("IP address")}</li>
              <li>{t("browser type")}</li>
              <li>{t("device type")}</li>
              <li>{t("operating system")}</li>
              <li>{t("session activity")}</li>
              <li>{t("interaction with platform features")}</li>
              <li>{t("log data")}</li>
              <li>{t("approximate location data based on IP")}</li>
            </ul>
            <p>{t("This information helps improve security and performance.")}

            </p>

            <h3>{t("3.3 Identity Verification Information")}</h3>
            <p>{t("To improve trust and reduce fraud risks, BaytBuddy may request identity verification documents such as:")}


            </p>
            <ul>
              <li>{t("National ID")}</li>
              <li>{t("Iqama")}</li>
              <li>{t("official identification documents")}</li>
            </ul>
            <p>{t("Identity verification helps maintain a trusted platform environment and reduce fraudulent activity.")}


            </p>
            <p>{t("Verification does not guarantee user behavior or credibility.")}

            </p>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("4. How We Use Your Information")}</h2>

            <div className="bb-privacy-page__subgroup">
              <h4>{t("Platform Operation")}</h4>
              <ul>
                <li>{t("creating and managing user accounts")}</li>
                <li>{t("enabling roommate matching")}</li>
                <li>{t("enabling listing creation and browsing")}</li>
                <li>{t("facilitating communication between users")}</li>
                <li>{t("enabling co-renting interactions")}</li>
              </ul>
            </div>

            <div className="bb-privacy-page__subgroup">
              <h4>{t("Security and Trust")}</h4>
              <ul>
                <li>{t("identity verification")}</li>
                <li>{t("fraud prevention")}</li>
                <li>{t("spam prevention")}</li>
                <li>{t("detecting suspicious activity")}</li>
                <li>{t("enforcing platform rules")}</li>
                <li>{t("maintaining community safety")}</li>
              </ul>
            </div>

            <div className="bb-privacy-page__subgroup">
              <h4>{t("Platform Improvement")}</h4>
              <ul>
                <li>{t("improving features")}</li>
                <li>{t("analyzing usage patterns")}</li>
                <li>{t("fixing technical issues")}</li>
                <li>{t("enhancing user experience")}</li>
              </ul>
            </div>

            <div className="bb-privacy-page__subgroup">
              <h4>{t("Customer Support")}</h4>
              <ul>
                <li>{t("responding to inquiries")}</li>
                <li>{t("resolving disputes")}</li>
                <li>{t("providing technical assistance")}</li>
              </ul>
            </div>

            <div className="bb-privacy-page__subgroup">
              <h4>{t("Legal Compliance")}</h4>
              <ul>
                <li>{t("complying with applicable laws")}</li>
                <li>{t("responding to lawful requests from authorities")}</li>
                <li>{t("enforcing legal rights")}</li>
              </ul>
            </div>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("5. Legal Basis for Processing")}</h2>
            <p>{t("We process personal data based on:")}</p>
            <ul>
              <li>{t("user consent")}</li>
              <li>{t("performance of services requested by the user")}</li>
              <li>{t("legal obligations")}</li>
              <li>{t("legitimate business interests related to platform safety and improvement")}


              </li>
            </ul>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("6. How We Share Information")}</h2>
            <p>{t("BaytBuddy does not sell personal data.")}</p>
            <p>{t("We may share data only when necessary with:")}</p>

            <div className="bb-privacy-page__subgroup">
              <h4>{t("Other Users")}</h4>
              <p>{t("Limited profile information may be visible to other users, such as:")}


              </p>
              <ul>
                <li>{t("first name")}</li>
                <li>{t("profile photo, if enabled")}</li>
                <li>{t("preferences")}</li>
                <li>{t("listing details")}</li>
                <li>{t("compatibility indicators")}</li>
              </ul>
              <p>{t("Users control what information is displayed in their profiles.")}

              </p>
            </div>

            <div className="bb-privacy-page__subgroup">
              <h4>{t("Service Providers")}</h4>
              <p>{t("We may share data with trusted third parties that support platform operations, such as:")}


              </p>
              <ul>
                <li>{t("cloud hosting providers")}</li>
                <li>{t("identity verification providers")}</li>
                <li>{t("analytics providers")}</li>
                <li>{t("payment processors")}</li>
                <li>{t("communication tools")}</li>
                <li>{t("cybersecurity providers")}</li>
              </ul>
              <p>{t("These providers are required to maintain confidentiality and security.")}


              </p>
            </div>

            <div className="bb-privacy-page__subgroup">
              <h4>{t("Legal Authorities")}</h4>
              <p>{t("We may disclose information if required by law or regulatory authorities within Saudi Arabia.")}


              </p>
            </div>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("7. Data Storage and Security")}</h2>
            <p>{t("We implement reasonable technical and organizational measures to protect personal data, including:")}


            </p>
            <ul>
              <li>{t("secure servers")}</li>
              <li>{t("restricted access controls")}</li>
              <li>{t("encryption protocols where applicable")}</li>
              <li>{t("monitoring of suspicious activity")}</li>
              <li>{t("incident response procedures")}</li>
              <li>{t("regular system updates")}</li>
            </ul>
            <p>{t("Security controls are aligned with recognized cybersecurity practices for private sector entities.")}


            </p>
            <p>{t("Despite our efforts, no digital system is completely secure.")}

            </p>
            <p>{t("Users share information at their own risk.")}</p>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("8. Data Retention")}</h2>
            <p>{t("We retain personal data only as long as necessary to:")}</p>
            <ul>
              <li>{t("provide services")}</li>
              <li>{t("comply with legal obligations")}</li>
              <li>{t("resolve disputes")}</li>
              <li>{t("enforce agreements")}</li>
              <li>{t("maintain security records")}</li>
            </ul>
            <p>{t("We may retain limited information after account deletion if required for legal or security purposes.")}


            </p>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("9. User Rights")}</h2>
            <p>{t("Users may request to:")}</p>
            <ul>
              <li>{t("access their personal data")}</li>
              <li>{t("update their personal data")}</li>
              <li>{t("correct inaccurate data")}</li>
              <li>{t("delete their account")}</li>
              <li>{t("withdraw consent where applicable")}</li>
            </ul>
            <p>{t("Requests can be submitted via the contact information below.")}

            </p>
            <p>{t("Some data may be retained if required for legal compliance.")}

            </p>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("10. Cookies and Tracking Technologies")}</h2>
            <p>{t("We may use cookies or similar technologies to:")}</p>
            <ul>
              <li>{t("maintain login sessions")}</li>
              <li>{t("understand user behavior")}</li>
              <li>{t("improve platform performance")}</li>
              <li>{t("remember user preferences")}</li>
            </ul>
            <p>{t("Users may disable cookies in their browser settings, though some features may not function properly.")}


            </p>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("11. Third-Party Links")}</h2>
            <p>{t("The Platform may contain links to third-party websites or services.")}


            </p>
            <p>{t("We are not responsible for the privacy practices of third parties.")}

            </p>
            <p>{t("Users should review third-party privacy policies separately.")}</p>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("12. Children's Privacy")}</h2>
            <p>{t("BaytBuddy is not intended for individuals under 18 years old.")}</p>
            <p>{t("We do not knowingly collect personal data from minors.")}

            </p>
            <p>{t("If such data is identified, we will take reasonable steps to remove it.")}


            </p>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("13. International Data Transfers")}</h2>
            <p>{t("User data may be processed using cloud infrastructure or service providers that operate in multiple jurisdictions.")}


            </p>
            <p>{t("We take reasonable steps to ensure data protection standards are maintained.")}


            </p>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("14. Changes to this Privacy Policy")}</h2>
            <p>{t("We may update this Privacy Policy periodically.")}</p>
            <p>{t("Updated versions will be published on the Platform.")}</p>
            <p>{t("Continued use of the Platform indicates acceptance of updates.")}

            </p>
          </section>

          <section className="bb-privacy-page__section">
            <h2>{t("15. Contact Information")}</h2>
            <p>{t("For privacy-related inquiries:")}</p>
            <p>
              <strong>{t("Email:")}</strong>{t(" info@baytbuddy.com")}
            </p>
          </section>
        </Container>
      </main>

      <Footer />
    </div>;
}
